<template>
  <div class="robbing">
    <nav class="robbing-nav">
      <div class="robbing-nav-item" @click="gotoIng">进行中</div>
      <div
        class="robbing-nav-item"
        :class="{'select':statusType=='complete'}"
        @click="toggleType('complete')"
      >已完成</div>
      <div
        class="robbing-nav-item"
        :class="{'select':statusType=='cancel'}"
        @click="toggleType('cancel')"
      >已取消</div>
      <div class="robbing-nav-item" v-if="type==2" @click="gotoPaotuiOrderDownload">今日数据</div>
    </nav>
    <div class="empty-data" v-if="!haveData">
      <div>
        <i class="iconfont icon-similarproduct"></i>
      </div>
      <div>
        <p>暂无数据</p>
      </div>
    </div>

    <section class="robbing-order" v-for="item in paotuiOrders" :key="item._id">
      <figure class="robbing-order-item">
        <div class="order-item-top">
          <div class="item-top-left">
            <span>{{item.typeStr}}</span>
          </div>
          <div class="item-top-right">
            <span style="color: red;">状态：{{item.statusStr}}</span>
          </div>
        </div>
        <div class="weui-cells weui-cells_form" style="margin-top: 0px;">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>跑腿单号</p>
            </div>
            <div class="weui-cell__ft">{{item.orderNo}}</div>
          </div>
          <div class="weui-cell" v-if="item.type == 1">
            <div class="weui-cell__bd">
              <p>{{item.expressCompanyName}}</p>
            </div>
            <div class="weui-cell__ft">{{item.expressNo}}</div>
          </div>
          <div class="weui-cell" v-if="item.type == 1 && !item.isBoxStorage">
            <div class="weui-cell__bd">
              <p>货架： {{item.storageNo}}-{{item.tag}}</p>
            </div>
            <div class="weui-cell__ft">
              <i class="iconfont icon-mobilephone"></i>
              {{item.initiatorPhone}}
            </div>
          </div>
          <div class="weui-cell" v-else-if="item.type==1 && item.isBoxStorage">
            <div class="weui-cell__bd">
              <p>
                {{item.storageNo&&item.storageNo!='默认'?item.storageNo+'号柜，':''}}
                <span style="color: red; font-weight: bold;">{{item.password}}</span>
              </p>
            </div>
            <div class="weui-cell__ft">
              <i class="iconfont icon-mobilephone"></i>
              {{item.initiatorPhone}}
            </div>
          </div>
          <div class="weui-cell" v-if="item.expressTakein">
            <div class="weui-cell__bd">
              <p>待寄物品</p>
            </div>
            <div
              class="weui-cell__ft"
            >{{item.expressTakein.goodsName}} x{{item.expressTakein.goodsCount?item.expressTakein.goodsCount:1}}</div>
          </div>
          <div class="weui-cell" v-if="item.expressTakein && item.expressTakein.insureMoney">
            <div class="weui-cell__bd">
              <p>
                保价金额
                <span
                  style="font-size: 12px; color: gold;"
                >（保价费：{{item.expressTakein.insureFreight}} 元）</span>
              </p>
            </div>
            <div class="weui-cell__ft">{{item.expressTakein.insureMoney}} 元</div>
          </div>
        </div>
        <div class="robbing-order-add">
          <div class="order-add-start" style="flex: 3;">
            <div>
              <i class="iconfont icon-map" aria-hidden="true" style="font-weight: bold"></i>
            </div>
            <div style="padding: 4px;">{{item.startPoint}}</div>
          </div>
          <div
            class="order-add-to"
            style="border-left: 1px solid #eee; border-right: 1px solid #eee; color: #1aad19;"
          >
            <i class="iconfont icon-jiantou2" aria-hidden="true" style="font-size: 32px;"></i>
          </div>
          <div class="order-add-end" style="flex: 3;">
            <div>
              <i class="iconfont icon-map" aria-hidden="true" style="font-weight: bold"></i>
            </div>
            <div style="padding: 4px;">{{item.endPoint}}</div>
          </div>
        </div>

        <div class="robbing-order-msg">
          <div class="order-msg-item" style="flex: 1" v-if="type == 1">
            <i class="iconfont icon-kuaidiyuan-xianxing" style="font-size: 18px;"></i>
            {{item.acceptUser?item.acceptUser:'暂无'}}
            <a
              :href="'tel:'+item.acceptUserPhone"
              v-if="item.acceptUserPhone"
              style="color: blue;"
            >
              <i class="iconfont icon-mobilephone"></i>
            </a>
          </div>
          <div class="order-msg-item" style="flex: 1" v-if="type == 2">
            <i class="iconfont icon-account"></i>
            {{item.proxyReceiver?item.proxyReceiver:item.initiator}}
            <a
              :href="'tel:'+(item.proxyReceiverPhone||item.initiatorPhone)"
              style="color: blue;"
            >
              <i class="iconfont icon-mobilephone"></i>
            </a>
          </div>
          <div class="order-msg-item" style="flex: 1">
            <i class="iconfont icon-daxiao" aria-hidden="true"></i>
            {{item.goodsType==1?"小件":""}}{{item.goodsType==2?"中件":""}}{{item.goodsType==3?"大件":""}}{{item.goodsName?item.goodsName:""}}
          </div>
          <div class="order-msg-item" style="flex: 1">
            <i class="iconfont icon-rmb" aria-hidden="true"></i>
            {{item.payFee/100}}元
          </div>
        </div>

        <div class="robbing-order-msg" v-if="item.type==2 && item.haveFreight">
          <div class="order-msg-item" style="flex: 1">
            {{item.expressCompanyName}}
            <span
              v-if="!item.expressTakein.isDaofu"
            >（￥{{item.freight / 100}} 元）</span>
            <span v-if="item.expressTakein.isDaofu">（到付）</span>
          </div>
        </div>

        <div class="robbing-order-remark">
          <div class="order-remark-left" align="center">描述</div>
          <div class="order-remark-center">
            <div
              class="order-item-time"
              style="font-size: 14px; margin-right: 60px; min-height: 60px;"
            >
              <!-- <p style="font-weight: bold; color: red;">跑腿性别要求： {{item.sexLimitStr}}</p> -->
              <p>
                时间：
                <span style="color: orangered; font-weight: bold;">{{item.serviceTime}}</span>
              </p>
              <p>备注： {{item.remark?item.remark:'无'}}</p>
            </div>
          </div>
          <div class="order-remark-right" v-if="item.qrimgBase64">
            <img
              class="block-img"
              :src="item.qrimgBase64"
              alt
              @click="showImagePreview(item.qrimgBase64)"
            />
          </div>
        </div>

        <div
          class="weui-cells"
          style="margin-top: -1px;"
          v-if="type==2 && item.status!=2 && item.goodsPic"
        >
          <a
            class="weui-cell weui-cell_access"
            href="javascript:;"
            @click="showImagePreview(item.goodsPic)"
          >
            <div class="weui-cell__bd">
              <p>待寄物品照片</p>
            </div>
            <div class="weui-cell__hd">
              <img class="block-img" :src="item.goodsPic" alt />
            </div>
          </a>
        </div>

        <div class="weui-cells weui-cells_form" style="margin-top: -1px;">
          <div class="weui-cell" v-if="item.rewardMoney > 0">
            <div class="weui-cell__bd">
              <p>额外赏金</p>
            </div>
            <div class="weui-cell__ft">{{item.rewardMoney / 100}} 元</div>
          </div>
        </div>
        <div class="robbing-order-msg" v-if="item.tags.length > 0">
          <div class="order-msg-item comment">
            <span
              :class="{'comment-good': (tag==1||tag==3), 'comment-bad':(tag==2||tag==4)}"
              v-for="tag in item.tags"
              :key="tag"
            >
              <font v-if="tag==1">态度好</font>
              <font v-if="tag==2">态度差</font>
              <font v-if="tag==3">准时到达</font>
              <font v-if="tag==4">超时到达</font>
            </span>
          </div>
        </div>
        <a
          href="javascript:;"
          class="robbing-order-get clickable"
          v-if="type== 1 && item.status==100 && item.toComment && userInfo.openid==item.openid"
          @click="comment(item)"
        >评价领活跃度</a>
      </figure>
    </section>
    <div
      v-infinite-scroll="loadmore"
      infinite-scroll-disabled="isScrollBusy"
      infinite-scroll-distance="30"
    >
      <div align="center" style="margin-top: 10px; margin-bottom: 10px;">
        <cube-loading style="width: 24px;" v-if="isScrollBusy && !isScrollEnd" />
        <span style="color: #999999; font-size: 0.8rem;" v-else-if="isScrollEnd && haveData">没有更多了</span>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config/config.js";
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
import io from "socket.io-client";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      haveData: true,
      worksiteId: "",
      userInfo: {},
      type: "",
      statusType: "",
      escPicker: [
        {
          label: "请选择",
          value: ""
        }
      ],
      year: moment().format("YYYY"),
      imgs: [],
      paotuiOrders: [],
      isScrollBusy: false,
      isScrollEnd: false,
      pageNo: 0,
      pageCount: 0
    };
  },
  created() {
    let that = this;
    this.type = this.$route.params.type;
    this.statusType = this.$route.params.status;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        this.userInfo = response.data.data;
        this.worksiteId = response.data.data.worksite._id;

        if (this.type == 2 && this.userInfo.paotuiStatus != 1) {
          // 我领取的，需要判断是否是跑腿，不是跑腿则跳转到跑腿申请页面
          this.$router.push("/paotuiApply/" + this.encodeToken);
          return;
        }
      })
      .catch(error => {
        this.haveData = false;
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    loadmore() {
      this.isScrollBusy = true;
      if (this.isScrollEnd) {
        return;
      }
      this.pageNo = this.pageNo + 1;
      let params = {
        statusStr: this.statusType,
        type: this.type,
        pageNo: this.pageNo
      };

      setTimeout(() => {
        axios
          .get("/api/paotuiOrder/pagingForFontend", { params })
          .then(res => {
            this.isScrollBusy = false;
            if (res.data.success) {
              this.pageCount = res.data.data.pageCount;
              if (this.pageCount > 0) {
                this.haveData = true;
              } else {
                this.haveData = false;
              }
              for (let i = 0; i < res.data.data.results.length; i++) {
                this.paotuiOrders.push(res.data.data.results[i]);
              }

              if (res.data.data.pageNumber >= this.pageCount) {
                this.isScrollEnd = true;
              } else {
                this.isScrollEnd = false;
              }

              for (let i = 0; i < this.paotuiOrders.length; i++) {
                // 跑腿性别要求
                if (
                  !this.paotuiOrders[i].sexLimit ||
                  this.paotuiOrders[i].sexLimit == -1
                ) {
                  this.paotuiOrders[i].sexLimitStr = "不限";
                } else if (this.paotuiOrders[i].sexLimit == 1) {
                  this.paotuiOrders[i].sexLimitStr = "男";
                }
                if (this.paotuiOrders[i].sexLimit == 2) {
                  this.paotuiOrders[i].sexLimitStr = "女";
                }

                let du = moment.duration(
                  moment(this.paotuiOrders[i].requireArriveTime) - moment(),
                  "ms"
                );
                this.paotuiOrders[i].timeLeft = du.locale("zh-cn").humanize();
                if (this.paotuiOrders[i].type == 1) {
                  this.paotuiOrders[i].typeStr = "送件上门";
                } else if (this.paotuiOrders[i].type == 2) {
                  this.paotuiOrders[i].typeStr = "上门取件";
                } else if (this.paotuiOrders[i].type == 3) {
                  this.paotuiOrders[i].typeStr = "餐饮服务";
                } else if (this.paotuiOrders[i].type == 4) {
                  this.paotuiOrders[i].typeStr = "其他服务";
                }

                if (this.paotuiOrders[i].qrimgBase64) {
                  this.paotuiOrders[i].qrimgBase64 =
                    "data:image/png;base64," + this.paotuiOrders[i].qrimgBase64;
                }

                let toDayStr = moment().format("YYYY-MM-DD");
                let nextDayStr = moment()
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                let next2DayStr = moment()
                  .add(2, "days")
                  .format("YYYY-MM-DD");
                let doorServiceDayStr = moment(
                  this.paotuiOrders[i].requireArriveTime
                ).format("YYYY-MM-DD");
                if (doorServiceDayStr == toDayStr) {
                  this.paotuiOrders[i].serviceTime =
                    "今天 " +
                    moment(this.paotuiOrders[i].requireArriveTime).format(
                      "HH点:mm分"
                    ) +
                    "前";
                } else if (doorServiceDayStr == nextDayStr) {
                  this.paotuiOrders[i].serviceTime =
                    "明天 " +
                    moment(this.paotuiOrders[i].requireArriveTime).format(
                      "HH点:mm分"
                    ) +
                    "前";
                } else if (doorServiceDayStr == next2DayStr) {
                  this.paotuiOrders[i].serviceTime =
                    "后天 " +
                    moment(this.paotuiOrders[i].requireArriveTime).format(
                      "HH点:mm分"
                    ) +
                    "前";
                } else {
                  let du = moment.duration(
                    moment(this.paotuiOrders[i].requireArriveTime) - moment(),
                    "ms"
                  );
                  this.paotuiOrders[i].serviceTime =
                    du.locale("zh-cn").humanize() + "前";
                }

                // 状态
                if (this.paotuiOrders[i].status == -1) {
                  this.paotuiOrders[i].statusStr = "待支付";
                } else if (this.paotuiOrders[i].status == 0) {
                  this.paotuiOrders[i].statusStr = "待接单";
                } else if (this.paotuiOrders[i].status == 1) {
                  this.paotuiOrders[i].statusStr = "已接单";
                } else if (this.paotuiOrders[i].status == 2) {
                  if (
                    this.paotuiOrders[i].type == 1 ||
                    this.paotuiOrders[i].type == 3 ||
                    this.paotuiOrders[i].type == 4
                  ) {
                    this.paotuiOrders[i].statusStr = "已领货";
                  } else if (this.paotuiOrders[i].type == 2) {
                    this.paotuiOrders[i].statusStr = "待跑腿确认";
                  }
                } else if (this.paotuiOrders[i].status == 3) {
                  if (
                    this.paotuiOrders[i].type == 1 ||
                    this.paotuiOrders[i].type == 3 ||
                    this.paotuiOrders[i].type == 4
                  ) {
                    this.paotuiOrders[i].statusStr = "已送达";
                  } else if (this.paotuiOrders[i].type == 2) {
                    this.paotuiOrders[i].statusStr = "待核算运费";
                  }
                } else if (this.paotuiOrders[i].status == 4) {
                  this.paotuiOrders[i].statusStr = "已取消";
                } else if (this.paotuiOrders[i].status == 5) {
                  this.paotuiOrders[i].statusStr = "待出库";
                } else if (this.paotuiOrders[i].status == 10) {
                  this.paotuiOrders[i].statusStr = "待付运费";
                } else if (this.paotuiOrders[i].status == 20) {
                  if (that.paotuiOrders[i].expressTakein.isDaofu) {
                    that.paotuiOrders[i].statusStr = "到付待件到站";
                  } else {
                    that.paotuiOrders[i].statusStr = "已付待件到站";
                  }
                } else if (this.paotuiOrders[i].status == 100) {
                  this.paotuiOrders[i].statusStr = "已完成";
                }

                if (
                  this.paotuiOrders[i].expressTakein &&
                  this.paotuiOrders[i].expressTakein.insureMoney
                ) {
                  if (this.paotuiOrders[i].expressTakein.insureMoney) {
                    this.paotuiOrders[
                      i
                    ].expressTakein.insureFreight = Math.ceil(
                      (this.paotuiOrders[i].expressTakein.insureMoney *
                        config.insurePercent) /
                        100
                    );
                  } else {
                    this.paotuiOrders[i].expressTakein.insureFreight = 0;
                  }
                }
              }
            } else {
              weui.alert(res.data.message);
            }
          })
          .catch(err => {
            console.log(err);
            this.isScrollBusy = false;
            this.haveData = false;
            weui.topTips("获取跑腿单数据出错", 2000);
          });
      }, 500);
    },
    showImagePreview(img) {
      this.imgs = [img];
      this.$createImagePreview({
        imgs: this.imgs
      }).show();
    },
    toggleType(type) {
      let that = this;
      if (this.statusType != type) {
        this.statusType = type;
        this.pageNo = 0;
        this.pageCount = 0;
        this.isScrollEnd = false;
        this.paotuiOrders = [];
        this.haveData = true;
        this.loadmore();
      }
    },
    gotoIng() {
      this.$router.push(
        "/robbingList/" + this.type + "/ing/" + this.encodeToken
      );
    },
    gotoPaotuiOrderDownload() {
      this.$router.push("/paotuiOrderForDownload/" + this.encodeToken);
    },
    comment(item) {
      this.$router.push(
        "/comment/" +
          item._id +
          "/" +
          item.acceptOpenid +
          "/" +
          encodeURIComponent(item.acceptUser) +
          "/" +
          encodeURIComponent(item.realArriveTime) +
          "/" +
          this.encodeToken
      );
    }
  },
  mounted() {
    this.loadmore();
  }
};
</script>
<style scoped>
.robbing {
  font-size: 14px;
  margin: 0 auto;
}
.robbing-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  text-align: center;
}
.robbing-nav-item {
  flex: 1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
}
.robbing-nav-item:last-child {
  border-right: none;
}
.robbing-nav-item.select {
  color: red;
  border-bottom: 1px solid red;
}
.robbing-title {
  height: 60px;
  line-height: 60px;
  background-color: rgb(36, 36, 36);
  display: flex;
  margin-top: 10px;
}
.robbing-title-left {
  width: 60px;
  height: 60px;
}
.robbing-title-left img {
  padding: 0px;
  width: 58px;
  height: 58px;
  object-fit: cover;
}
.robbing-title-center {
  flex: 1;
  background-color: #1aad19;
  color: white;
  text-align: left;
  padding-left: 20px;
  font-size: 16px;
  letter-spacing: 2px;
}
.robbing-title-center span {
  font-weight: bold;
}
.robbing-title-center .small-tip {
  font-size: 8px;
}
.robbing-title-center p:first-child {
  height: 32px;
  line-height: 32px;
}
.robbing-title-center p:last-child {
  height: 26px;
  line-height: 1em;
}
.robbing-title-right {
  width: 100px;
}
.robbing-go {
  width: 80px;
  height: 20px;
  line-height: 20px;
  display: inline-block;
  color: white;
  background-color: #1aad19;
  border-radius: 5px;
  font-size: 12px;
}

.robbing-progress {
  display: flex;
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #eee;
  color: grey;
}
.robbing-progress-item {
  flex: 1;
}
.robbing-progress-item.clickable {
  color: orangered;
}
.robbing-progress-item.warning {
  color: gold;
}
.robbing-progress-item.done {
  color: #1aad19;
}
.progress-item-top {
  line-height: 1em;
  font-size: 32px;
  padding-top: 8px;
}
.progress-item-top i {
  font-size: 30px;
}
.progress-item-bottom {
  line-height: 1em;
}

.robbing .icon-daxiao-,
.order-add-to {
  font-size: 34px;
}
.robbing-order {
  margin-bottom: 10px;
}
.robbing-order-item {
  position: relative;
  margin-left: 10px;
  margin-right: 10px;
}
.order-item-top {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eee;
  border-top: #1aad19 3px solid;
}
.item-top-left {
  position: absolute;
  left: 10px;
  top: 0px;
  padding-top: 2px;
}
.item-top-left span {
  padding: 3px 5px;
  color: orange;
  border: 1px solid orange;
  border-radius: 3px;
  font-size: 12px;
}
.item-top-right {
  position: absolute;
  right: 10px;
  top: 0px;
  font-size: 14px;
  padding-top: 2px;
}
.robbing-order-add {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  text-align: center;
}
.order-add-start {
  white-space: normal;
  word-break: break-all;
  width: 120px;
  position: relative;
}
.order-add-start:before {
  content: "";
  position: absolute;
  right: 0px;
  top: -60px;
  border-left: 1px solid #eee;
  width: 1px;
}
.order-add-start i {
  color: rgb(37, 155, 36);
  font-size: 23px;
  position: relative;
  top: 3px;
}
.order-add-end {
  padding-right: 5px;
  width: 120px;
  position: relative;
}
.order-add-end:before {
  content: "";
  position: absolute;
  left: 0px;
  top: -60px;
  border-left: 1px solid #eee;
  width: 1px;
}
.order-add-end i {
  color: rgb(212, 54, 29);
  font-size: 23px;
  position: relative;
  top: 3px;
}
.order-add-to {
  flex: 1;
}
.robbing-order-msg {
  display: flex;
  align-items: center;
  height: 40px;
  border-bottom: 1px solid #eee;
}
.order-msg-item {
  flex: 1;
  text-align: center;
}
.robbing-order-remark {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  overflow: hidden;
  padding: 5px;
}
.order-remark-left {
  width: 60px;
  position: absolute;
  left: 0;
  right: 0;
}
.order-remark-center {
  text-align: left;
  border-left: 1px solid #eee;
  margin-left: 56px;
  padding-left: 10px;
}
.marginRight60 {
  margin-right: 60px;
}
.order-remark-right {
  width: 60px;
  position: absolute;
  right: 0px;
}
.robbing-order-get {
  display: block;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: white;
  font-size: 16px;
}
.robbing-order-get.clickable {
  background-color: orangered;
}
.robbing-order-get.unclickable {
  background-color: grey;
}
.robbing-order-get.warning {
  background-color: gold;
}
.robbing-order-get.success {
  background-color: #1aad19;
}
.robbing-order-get.disable {
  background-color: grey;
}
.robbing-order-item {
  margin-top: 10px;
}
.robbing-order-push {
  display: block;
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  line-height: 18px;
  font-size: 15px;
  color: white;
  border-radius: 100%;
  background-color: rgb(37, 155, 36);
}
.robbing-order-push span {
  display: inline-block;
  margin-top: 12px;
}
.empty-data {
  text-align: center;
  margin-top: 50px;
}
.empty-data div i {
  font-size: 120px;
  color: #cccccc;
}
.empty-data div p {
  font-size: 30px;
  color: #cccccc;
}
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.go-pay {
  background-color: #1aad19;
  color: #ffffff;
  padding: 3px 5px;
  font-size: 12px;
  border-radius: 3px;
}
.zhuandan-single {
  background-color: lightseagreen;
  color: #ffffff;
  padding: 3px 5px;
  font-size: 12px;
  border-radius: 3px;
  margin-left: 10px;
  margin-right: 10px;
}
.zhuandan-batch {
  background-color: orangered;
  color: #ffffff;
  padding: 3px 5px;
  font-size: 12px;
  border-radius: 3px;
}
.go-cancel {
  background-color: orangered;
  color: #ffffff;
  padding: 3px 5px;
  font-size: 12px;
  border-radius: 3px;
}
.block-img {
  width: 60px;
  height: 60px;
}
.mail-tips {
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: yellow;
}
.weui-cells_form .weui-cell__ft {
  font-size: 17px;
}
.paotui-order-no {
  flex: 1;
  text-align: left;
  margin-left: 10px;
  font-size: 18px;
}
.comment {
  flex: 1;
  text-align: left;
  margin-left: 10px;
}
.comment-good {
  background-color: green;
  padding: 2px 4px;
  color: #ffffff;
  font-size: 12px;
  border-radius: 3px;
  margin-left: 5px;
  margin-right: 5px;
}
.comment-bad {
  background-color: red;
  padding: 2px 4px;
  color: #ffffff;
  font-size: 12px;
  border-radius: 3px;
  margin-left: 5px;
  margin-right: 5px;
}
.warehousing-footer-item {
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 0px;
  line-height: 50px;
  color: #ffffff;
}
.warehousing-footer-item a {
  color: #ffffff;
}
.cancel-batch {
  background-color: orangered;
}
.batch-begin {
  background-color: lightseagreen;
}
.footer {
  width: 100%;
  position: fixed;
  bottom: 0;
}
</style>
<style>
.weui-picker__item {
  font-size: 18px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/RobbingListCompleteOrCancel.vue